import React from 'react';

const ChatItem = ({ chat, isActive, onSelect }) => (
  <div
    className={`chat-item ${isActive ? 'active' : ''}`}
    onClick={() => onSelect(chat.user)}
  >
    <div className="profile-picture">
      {chat.profilePicture ? (
        <img src={chat.profilePicture} alt={chat.user} />
      ) : (
        <div className="default-profile-picture"></div>
      )}
    </div>
    <div className="chat-details">
      <span className="chat-user">{chat.user}</span>
      <span className="chat-snippet">{getLastMessageSnippet(chat.messages)}</span>
    </div>
  </div>
);

const getLastMessageSnippet = (messages) => {
  if (messages.length === 0) return '';
  const lastMessage = messages[messages.length - 1].text;
  return lastMessage.length > 20 ? lastMessage.substring(0, 20) + '...' : lastMessage;
};

export default ChatItem;
